import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService, AuthConfigService } from '@argalis-apps/angular-core';
import { MUser } from '@argalis-apps/models';
import { Observable, Subject } from 'rxjs';
import { MenuStoreService } from '@argalis-apps/angular-services';
import { DemandeEncadrementService } from '@argalis-apps/angular-core';

@Component({
  selector: 'app-argalis-apps-main-ui',
  templateUrl: './main-ui.component.html',
  styleUrls: ['./main-ui.component.scss']
})
export class MainUiComponent implements OnInit, OnDestroy {
  private notificationSubscriber;
  public sidebarClosed: boolean = void 0;
  public userConnected: MUser.CUser;
  public signout: Observable<any>;
  public userChange: Subject<MUser.CUser>;
  public themingClassName: string;
  public menu: Array<{
    libelle: string;
    routerLink: string;
    icon: string;
    badgeNumber?: number;
  }> = [
      {
        libelle: 'Mon tableau de bord',
        routerLink: '/',
        icon: 'dashboard'
      },
      {
        libelle: 'Mon agenda',
        routerLink: '/calendar',
        icon: 'calendar_today'
      },
      {
        libelle: 'Mes sessions',
        routerLink: '/account/sessions',
        icon: 'format_list_bulleted'
      }
    ];

  constructor(
    private authService: AuthService,
    private authConfigService: AuthConfigService,
    private menuStoreService: MenuStoreService,
    private demandeEncadrementService: DemandeEncadrementService
  ) { }

  ngOnInit() {
    this.userConnected = this.authService.userConnected || null;
    // vérifier si on est en mode test avec "fake data"
    // Ajouter .subscribe si on veut faire un signout
    this.signout = this.authService.signout();
    this.userChange = this.authService.userChange || null;
    this.themingClassName = this.authConfigService.themingClassName;
    if (this.userConnected && !this.userConnected.userInfo.b_ost) {
      this.menu.push({
        libelle: "Mes demandes d'encadrement",
        routerLink: '/demandes',
        icon: 'notifications',
        badgeNumber: 0,
      })
    }
    // on met à jour le nombre de notification en temps réel
    this.notificationSubscriber = this.menuStoreService.notificationNumberChange$.subscribe((numberAlert: number) => {
      this.menu.forEach(menu => {
        if (menu.icon === 'notifications') {
          menu.badgeNumber = numberAlert;
        }
      });
    });
    this.notificationSubscriber = this.demandeEncadrementService
      .getListById(this.userConnected.userInfo.id)
      .subscribe(res => {
        this.menuStoreService.emitNotificationNumber(Number(res.length || 0));
      });
  }

  ngOnDestroy() {
    this.notificationSubscriber.unsubscribe();
  }

  togglePageWrapperWidth(isClosed: boolean) {
    this.sidebarClosed = isClosed;
  }
}
